import { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "@mui/icons-material"
import { percentageFormatter } from "helpers/formatters/numbers"
import { getFactorDisabled } from "helpers/factors"

class Factor extends Component {
  onClick = () => {
    const { factor, openFactorProfile } = this.props
    openFactorProfile(factor.id)
  }

  render() {
    const { max, factor, otherLabel } = this.props
    const chartWidth = Math.abs(factor.value) / max * 100

    const link = factor.id === "other" || getFactorDisabled(factor.category)
      ? <span className="item-label-container">{factor.label || otherLabel}</span>
      : <a onClick={this.onClick}><span className="item-label-container">{factor.label || otherLabel}</span><Link className="icon" /></a>

    return <div className="attribution-item-wrapper">
      <div className="attribution-item-label" title={factor.label || otherLabel}>
        {link}
      </div>
      <div className="attribution-chart-bar">
        <div className="bar" style={{ width: `${chartWidth}%` }} />
      </div>
      <div className="attribution-chart-value">
        {percentageFormatter(factor.value)}
      </div>
    </div>
  }
}

Factor.propTypes = {
  factor: PropTypes.object.isRequired,
  otherLabel: PropTypes.string.isRequired,
  max: PropTypes.number.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
}

export default Factor
